import styled from "styled-components";
import { colors } from "../../styles/colors";
import { Spacer } from "../Spacer";
import { QiviaLogoDark } from "../../assets/assets";
import { SpinnerDS } from "../../designSystem/components/Loader/SpinnerDS";

export interface LaunchPageProps {
  hasBorderRadius?: boolean;
  toaster?: JSX.Element;
}

export const LaunchPage = (props: LaunchPageProps) => {
  return (
    <StyledLaunchPage $hasBorderRadius={props.hasBorderRadius || false}>
      {props.toaster}
      <img src={QiviaLogoDark} alt="Qivia" style={{ height: "2.5rem" }} />
      <Spacer y={5} />
      <SpinnerDS />
    </StyledLaunchPage>
  );
};

const StyledLaunchPage = styled.div<{ $hasBorderRadius: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem 0 0 0.75rem;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: ${colors.white};
  border-radius: ${({ $hasBorderRadius }) =>
    $hasBorderRadius && "0.75rem 0 0 0.75rem"};
`;
